import { useEffect, useState } from "react";
import api, { inr } from "../api";

// Shared treatment dropdown — the same treatment master everywhere (patients, appointments, follow-ups, leads).
export default function TreatmentSelect({ value, onChange, testid, className = "" }) {
  const [treatments, setTreatments] = useState([]);
  useEffect(() => {
    api.get("/connect/treatments").then((r) => setTreatments((r.data || []).filter((t) => t.active !== false))).catch(() => {});
  }, []);
  return (
    <select
      data-testid={testid}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={`h-11 w-full rounded-xl border border-pine/15 px-3.5 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-pine ${className}`}
    >
      <option value="">Select treatment</option>
      {treatments.map((t) => (
        <option key={t.id} value={t.name}>
          {t.name}{t.price ? ` — ${inr(t.price)}` : ""}{t.duration ? ` · ${t.duration}` : ""}
        </option>
      ))}
      {value && !treatments.some((t) => t.name === value) && <option value={value}>{value}</option>}
    </select>
  );
}
